import React from "react";

interface Props {
    size?: number;
    color?: string;
}

const TooltipInfo: React.FC<Props> = ({
    size = 18,
    color = "currentColor",
}) => {
    return (
        <svg width={size}
            height={size}
            fill={color} viewBox="0 0 13 15" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_169_3477)">
                <path d="M8.80005 11.2251V9.9751C8.80005 9.90218 8.77661 9.84229 8.72974 9.79541C8.68286 9.74854 8.62297 9.7251 8.55005 9.7251H7.80005V5.7251C7.80005 5.65218 7.77661 5.59229 7.72974 5.54541C7.68286 5.49854 7.62297 5.4751 7.55005 5.4751H5.05005C4.97713 5.4751 4.91724 5.49854 4.87036 5.54541C4.82349 5.59229 4.80005 5.65218 4.80005 5.7251V6.9751C4.80005 7.04801 4.82349 7.10791 4.87036 7.15479C4.91724 7.20166 4.97713 7.2251 5.05005 7.2251H5.80005V9.7251H5.05005C4.97713 9.7251 4.91724 9.74854 4.87036 9.79541C4.82349 9.84229 4.80005 9.90218 4.80005 9.9751V11.2251C4.80005 11.298 4.82349 11.3579 4.87036 11.4048C4.91724 11.4517 4.97713 11.4751 5.05005 11.4751H8.55005C8.62297 11.4751 8.68286 11.4517 8.72974 11.4048C8.77661 11.3579 8.80005 11.298 8.80005 11.2251ZM7.80005 4.2251V2.9751C7.80005 2.90218 7.77661 2.84229 7.72974 2.79541C7.68286 2.74854 7.62297 2.7251 7.55005 2.7251H6.05005C5.97713 2.7251 5.91724 2.74854 5.87036 2.79541C5.82349 2.84229 5.80005 2.90218 5.80005 2.9751V4.2251C5.80005 4.29801 5.82349 4.35791 5.87036 4.40479C5.91724 4.45166 5.97713 4.4751 6.05005 4.4751H7.55005C7.62297 4.4751 7.68286 4.45166 7.72974 4.40479C7.77661 4.35791 7.80005 4.29801 7.80005 4.2251ZM11.9954 4.46338C11.9954 4.46338 12.1295 4.6932 12.3977 5.15283C12.6659 5.61247 12.8 6.38656 12.8 7.4751C12.8 8.56364 12.5318 9.56755 11.9954 10.4868C11.4589 11.4061 10.731 12.134 9.81177 12.6704C8.8925 13.2069 7.88859 13.4751 6.80005 13.4751C5.71151 13.4751 4.7076 13.2069 3.78833 12.6704C2.86906 12.134 2.14119 11.4061 1.60474 10.4868C1.06828 9.56755 0.800049 8.56364 0.800049 7.4751C0.800049 6.38656 1.06828 5.38265 1.60474 4.46338C2.14119 3.54411 2.86906 2.81624 3.78833 2.27979C4.7076 1.74333 5.71151 1.4751 6.80005 1.4751C7.88859 1.4751 8.8925 1.74333 9.81177 2.27979C10.731 2.81624 11.4589 3.54411 11.9954 4.46338Z" fill="#1E2F56" />
            </g>
            <defs>
                <clipPath id="clip0_169_3477">
                    <rect width="12" height="14.4" fill="white" transform="matrix(1 0 0 -1 0.800049 14.6743)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default TooltipInfo;




